import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import VueForm from '@lljj/vue3-form-element'
import { Vue3JsonEditor } from 'vue3-json-editor'
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError }  from 'axios'
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import App from './App.vue'
import router from './router'
import store, { key } from './store'
import { RespData } from './store/respTypes'
import 'element-plus/dist/index.css'
export type ICustomAxiosConfig = AxiosRequestConfig & {
  opName?: string;
}
const isEnglish = process.env.VUE_APP_IS_ENGLISH === 'true'
const isDevOrStaging = process.env.NODE_ENV === 'development' || process.env.VUE_APP_STAGINE
// 开发/测试环境使用测试域名，生产环境根据语言选择域名
export const baseAPIURL = isDevOrStaging 
  ? 'https://test.vikingship.uk' 
  : (isEnglish ? 'https://api.tailwindresume.co' : 'https://api.easycv.cn')


axios.defaults.baseURL = baseAPIURL
axios.defaults.withCredentials = true
axios.interceptors.request.use(config => {
  const newConfig = config as ICustomAxiosConfig
  store.commit('setError', { status: false, message: ''})
  store.commit('startLoading', { opName: newConfig.opName })
  return config
})

axios.interceptors.response.use((resp: AxiosResponse<RespData>) => {
  const { config, data } = resp
  const newConfig = config as ICustomAxiosConfig
  store.commit('finishLoading', { opName: newConfig.opName })
  return resp
}, (e: AxiosError) => {
  const newConfig = e.config as ICustomAxiosConfig
  const resp = e.response as AxiosResponse<RespData>
  const { message } = resp.data
  store.commit('setError', { status: true, message })
  store.commit('finishLoading', { opName: newConfig.opName })
  return Promise.reject(e)
})
const app = createApp(App)
app.component('VueForm', VueForm)
app.component('Vue3JsonEditor', Vue3JsonEditor)
app.provide('baseAPIURL', baseAPIURL)
app.use(ElementPlus, { locale }).use(store, key).use(router).mount('#app')
